import { z } from 'zod'

import { UserSubscriptionTier, SubscriptionEntitlement } from './userEnums'

export const SubscriptionDBModel = z.object({
  /// ('free', 'paid', 'enterprise') - determine if this is a free or paid tier
  tier: z.nativeEnum(UserSubscriptionTier),
  /// Number of months for this subscription before next renewal.
  duration_months: z.number().optional(),
  /// Total storage this subscription provides
  /// Updates the user.storage_quota on valid purchase
  storage_quota: z.number(),
  /// Apple specific product id, for In-App purchasing
  apple_product_id: z.string().optional(),
  /// Apple specific app bundle id, for filtering which subscriptions to show in-app.
  apple_app_bundle_id: z.string().optional(),
  /// Entitlements that this subscription endows.
  entitlements: z.array(z.nativeEnum(SubscriptionEntitlement)),
})

type SubscriptionDBModel = z.infer<typeof SubscriptionDBModel>

export const SubscriptionIdContainer = z.object({
  subscription_id: z.string(),
  subscription: SubscriptionDBModel,
})

export const freeSubscription = SubscriptionDBModel.parse({
  tier: 'free',
  storage_quota: 2000 * 1000 * 1000,
  entitlements: [
    SubscriptionEntitlement.ObjectScanning,
    SubscriptionEntitlement.MonocleGallery,
    SubscriptionEntitlement.MonocleVideoCapture,
    // SubscriptionEntitlement.XMeetRoomDesigner,
    SubscriptionEntitlement.PrimeJobsProcessing,
  ],
})
